import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { publicApi } from "./api";

const SettingsContext = createContext(null);

const FALLBACK = {
  ga4_id: "",
  meta_pixel_id: "",
  sales_name: "Kiel",
  sales_title: "Senior Sales Consultant BYD",
  sales_phone: "082272138537",
  sales_phone_intl: "6282272138537",
  sales_photo: "",
  instagram_url: "https://instagram.com/bydcibubur.official",
  instagram_handle: "@bydcibubur.official",
  dealer_image: "",
  dealer_name: "BYD Haka Auto Cibubur",
  dealer_address:
    "Jl. Alternatif Cibubur No.41, RT.002/RW.002, Jatikarya, Kec. Jatisampurna, Kota Bekasi, Jawa Barat 17435",
  site_domain: "https://dealerbydcibubur.id",
  wa_cta_text: "Dapatkan Hitungan Kredit Terbaik",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);
  const [loaded, setLoaded] = useState(false);

  const refetch = useCallback(() => {
    return publicApi
      .getSettings()
      .then((d) => {
        setSettings({ ...FALLBACK, ...d });
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, []);

  useEffect(() => {
    refetch();
    const onFocus = () => refetch();
    const onBump = () => refetch();
    window.addEventListener("focus", onFocus);
    window.addEventListener("byd:content-bump", onBump);
    return () => {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("byd:content-bump", onBump);
    };
  }, [refetch]);

  return (
    <SettingsContext.Provider value={{ settings, loaded, setSettings, refetch }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettings must be inside SettingsProvider");
  return ctx;
}

export function buildWaLink(settings, customMessage) {
  const phone = settings.sales_phone_intl || "6282272138537";
  const defaultMsg = `Halo ${settings.sales_name}, saya tertarik untuk konsultasi BYD di ${settings.dealer_name}. ${settings.wa_cta_text}.`;
  const msg = encodeURIComponent(customMessage || defaultMsg);
  return `https://wa.me/${phone}?text=${msg}`;
}
